import type { Staff } from '~/models/Staff';
import type { VendorUser } from './VendorUser';

export type DealUploadFile = {
  id: number;
  dealId: number;
  fileName: string;
  originalFilename: string | null;
  optionalFilename: string | null;
  createdAt: string;
  vendorUser: VendorUser;
  staff: Staff;
};

export type DealUploadFileUpdateParam = {
  id: number;
  optionalFilename: string | null;
};

export const canDestroy = (
  file: DealUploadFile,
  isVendor: boolean
): boolean => {
  // Adminで登録したファイルは常に削除できるようにする
  if (file.vendorUser === null && file.staff === null) return true;
  if (isVendor) {
    return file.vendorUser !== null;
  }
  return file.staff !== null;
};
